import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { convertJsonToYaml } from './Yaml';
import { contractApi } from '../../Users/defaults';
import styles from '../../common.module.css'


const DownloadPage = ({ jsonData }) => {
    const [selectedFormat, setSelectedFormat] = useState('');
    const [isDownloaded, setIsDownloaded] = useState(false);
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const showPopupModal = (title, message) => {
        setPopupTitle(title);
        setPopupMessage(message);
        setShowPopup(true);
    }

    const handleFormatChange = (event) => {
        setSelectedFormat(event.target.value);
        setIsDownloaded(false);
    };

    const validateConfig = (config) => {
        return !config.info || !config.info.title || !config.info.version
            ? 'API Name and Version are required before saving.'
            : null;
    };

    const handleSave = async (isDownloadProcess = false) => {
        const validationError = validateConfig(jsonData);
        if (validationError) {
            showPopupModal("Error", validationError);
            return;
        }
        setIsSaving(true);
        try {
            const response = await contractApi.post('/contract', jsonData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!isDownloadProcess) {
                response.status === 201
                    ? showPopupModal('Success', 'Configuration saved successfully!')
                    : showPopupModal('Error', 'Failed to save configuration.');
            }
        } catch (error) {
            console.error('Error saving configuration:', error);
            if (!isDownloadProcess)
                showPopupModal('Error', 'An error occurred while saving. Please try again.');
        } finally {
            setIsSaving(false);
        }
    };

    const handleDownload = async () => {
        handleSave(true);
        const title = jsonData.info?.title || 'output';

        try {
            let blob, link;

            if (selectedFormat === 'json') {
                blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
            } else if (selectedFormat === 'yaml') {
                const yamlString = convertJsonToYaml(jsonData);
                blob = new Blob([yamlString], { type: 'text/yaml' });
            }
            link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${title}.${selectedFormat}`;
            link.click();
            setIsDownloaded(true);
        } catch (error) {
            showPopupModal('Error', 'Error occurred while generating the file.');
        }
    };

    const handleBackToDashboard = () => {
        navigate('/dashboard');
    };

    useEffect(() => {
        if (isDownloaded) {
            showPopupModal('Success', 'File has been downloaded successfully.');
        }
    }, [isDownloaded]);

    return (
        <div style={{
            height: '100vh', 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center', 
          }}>
            <div
                style={{
                    padding: '20px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    width: '400px',
                    justifyContent: 'center',
                }}
            >
                <h2 className={styles.subtitle}>Download Your Configuration</h2>

                <div style={{ marginBottom: '20px' }}>
                    <label
                        style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            marginRight: '10px',
                            display: 'block',
                            marginBottom: '8px',
                            color: 'white',
                        }}
                    >
                        Select Format:
                    </label>
                    <select
                        value={selectedFormat}
                        onChange={handleFormatChange}
                        style={{
                            padding: '8px',
                            fontSize: '16px',
                            borderRadius: '4px',
                            width: '100%',
                        }}
                    >
                        <option value="">-- Choose Format --</option>
                        <option value="json">JSON</option>
                        <option value="yaml">YAML</option>
                    </select>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                    <button
                        onClick={handleSave}
                        style={{
                            flex: 1,
                            padding: '10px 20px',
                            fontSize: '16px',
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                    >
                        Save
                    </button>
                    <button
                        onClick={handleDownload}
                        disabled={!selectedFormat}
                        style={{
                            flex: 1,
                            padding: '10px 20px',
                            fontSize: '16px',
                            backgroundColor: selectedFormat ? '#007bff' : '#ccc',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: selectedFormat ? 'pointer' : 'not-allowed',
                        }}
                    >
                        Download
                    </button>
                </div>

                <button
                    onClick={handleBackToDashboard}
                    style={{
                        marginTop: '20px',
                        padding: '10px 20px',
                        fontSize: '16px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        width: '100%',
                    }}
                >
                    Back to Dashboard
                </button>

                <p style={{ marginTop: '20px', color: '#28a745', fontWeight: 'bold', fontSize: 8 }}>
                    🔹 Notice: To maintain data integrity and enhance your experience, configurations are automatically saved prior to download and accessible via Assets. No personal data is retained.
                </p>

            </div>
            {showPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        <h3>{popupTitle}</h3>
                        <p>{popupMessage}</p>
                        <button onClick={() => setShowPopup(false)} className="popup-close-button">
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DownloadPage;
